export default function StatusService() {
  'ngInject';

  var service = {};


  return service;
}